import {
  Droppable,
  type DroppableProvided,
  type DroppableStateSnapshot,
} from "@hello-pangea/dnd";
import { Text } from "@mantine/core";

import type {
  Column as ColumnType,
  User as UserType,
  UserMap,
} from "../CrewTransfer.model";
import { StyledColumn, StyledColumnDroppable } from "../styled/Column.styled";
import User from "./User";

interface Props {
  column: ColumnType;
  users: UserType[];
  selectedUsers: string[];
  draggingUserId: string | undefined | null;
  toggleSelection: (taskId: string) => void;
  toggleSelectionInGroup: (taskId: string) => void;
  multiSelectTo: (taskId: string) => void;
}

const getSelectedMap = (selectedTaskIds: string[]) =>
  selectedTaskIds.reduce((previous: UserMap, current: string): UserMap => {
    // @ts-expect-error FIX
    previous[current] = true;
    return previous;
  }, {});

const Column = ({
  column,
  users,
  selectedUsers,
  draggingUserId,
  toggleSelection,
  toggleSelectionInGroup,
  multiSelectTo,
}: Props) => {
  return (
    <StyledColumn>
      <Text fw={200} size="lg">
        {column.title}
      </Text>
      <Droppable droppableId={column.id}>
        {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
          <StyledColumnDroppable
            ref={provided.innerRef}
            isDraggingOver={snapshot.isDraggingOver}>
            {users.map((user, index) => {
              const isSelected = Boolean(
                getSelectedMap(selectedUsers)[user.id],
              );
              const isGhosting: boolean =
                isSelected &&
                Boolean(selectedUsers) &&
                draggingUserId !== user.id;

              return (
                <User
                  user={user}
                  index={index}
                  key={user.id}
                  isSelected={isSelected}
                  isGhosting={isGhosting}
                  selectionCount={selectedUsers.length}
                  toggleSelection={toggleSelection}
                  toggleSelectionInGroup={toggleSelectionInGroup}
                  multiSelectTo={multiSelectTo}
                />
              );
            })}
            {provided.placeholder}
          </StyledColumnDroppable>
        )}
      </Droppable>
    </StyledColumn>
  );
};
export default Column;
